import { CheckCircleOutlineRounded, ErrorOutlineOutlined } from "@mui/icons-material";
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import { Box, Grid, Typography } from '@mui/material';
import { CircularProgressProps } from "@mui/material/CircularProgress";
import { Property } from "csstype";
import { CircularProgressWithLabel } from "../Loading/CircularProgressWithLabel";

export interface SummarizeProgressData {
    importTypeId: number;
    importName: string;
    numberOfRowsCorrect: number;
    numberOfRowsFailed: number;
    isSuccess: boolean;
}

export function ImportProgressBarSummarize(props: CircularProgressProps & { value: number } & { progressData: SummarizeProgressData }
    & { iconHeight?: Property.Height<string | number> | undefined } & { iconWidth?: Property.Width<string | number> | undefined }) {

    return (
        <>
            {props.progressData?.isSuccess && props.progressData?.numberOfRowsCorrect === 0 && (
                <Grid container item key={props.progressData?.importTypeId} xs={3} display="flex" alignItems="center" spacing={2}>
                    <Grid item xs={2}>
                        <Box width={props.iconWidth} height={props.iconHeight}>
                            {props.value === 0
                                ?
                                <QueryBuilderOutlinedIcon color="secondary" style={{ width: props.iconWidth ?? 45, height: props.iconHeight ?? 45 }} />
                                : <CircularProgressWithLabel value={props.value} width={props.iconWidth ?? 45} height={props.iconHeight ?? 45} />}
                        </Box>
                    </Grid>
                    <Grid item xs={10}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 'regular' }} color="secondary">
                                {props.progressData?.importName}
                            </Typography>
                            <Typography variant="caption" sx={{ mt: 0, fontStyle: 'italic', fontSize: '12px' }}
                                color="secondary">
                                {props.value === 0 ? 'Import queued' : 'Import in progress'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            )}

            {!props.progressData?.isSuccess &&
                <Grid container item key={props.progressData?.importTypeId} xs={3} alignItems="center" spacing={2}>
                    <Grid item xs={2}>
                        <ErrorOutlineOutlined color="error" style={{ width: props.iconWidth ?? 45, height: props.iconHeight ?? 45 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 'regular' }} color="secondary">
                                {props.progressData?.importName}
                            </Typography>
                            <Typography variant="caption" sx={{ mt: 0, fontStyle: 'italic', fontSize: '10px' }}
                                color="secondary">
                                Import failed
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            }

            {props.progressData?.isSuccess && props.progressData?.numberOfRowsCorrect > 0 &&
                <Grid container item key={props.progressData?.importTypeId} xs={3} alignItems="center" spacing={2}>
                    <Grid item xs={2}>
                        <CheckCircleOutlineRounded color="success" style={{ width: props.iconWidth ?? 45, height: props.iconHeight ?? 45 }} />
                    </Grid>
                    <Grid item xs={10}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="body2" sx={{ mb: 0, fontWeight: 'regular' }} color="secondary">
                                {props.progressData?.importName}
                            </Typography>
                            <Typography variant="caption" sx={{ mt: 0, fontStyle: 'italic', fontSize: '10px' }}
                                color="secondary">
                                All {props.progressData?.numberOfRowsCorrect} records imported
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            }
        </>
    );
}